import { ToastContainer } from "react-toastify";
import "./App.css";
import AppRouter from "./router/AppRouter";
import { Helmet } from "react-helmet";


function App() {
  return (
    <>
      <Helmet>
        <link
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css"
          rel="stylesheet"
          integrity="sha384-KyZXEAg3QhqLMpG8r+Knujsl5+5hb7ie3nDmqzJ7tCkDckBJgd6xztc0K4Xr2D9X"
          crossorigin="anonymous"
        />
        <script
          src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js"
          integrity="sha384-ka7Sk0Gln4gmtz2MlQnikT1wXgYsOg+OMhuP+IlRH9sENBO0LRn5q+8nbTov4+1p"
          crossorigin="anonymous"
          defer
        ></script>
      </Helmet>
      <AppRouter />
      <ToastContainer />
    </>
  );
}

export default App;
